import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ChevronLeft } from 'lucide-react';

export default function TermsOfUse() {
  const { language } = useApp();

  // Set page title
  useEffect(() => {
    document.title = language === 'tr'
      ? 'Kullanım Şartları | Kastamonu Amorium Hotel'
      : 'Terms of Use | Kastamonu Amorium Hotel';
  }, [language]);

  return (
    <div style={{ minHeight: '100vh', background: '#F6F1E7' }}>
      <Navbar />
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '3rem 1.5rem' }}>
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#6E7F5B', textDecoration: 'none', marginBottom: '2rem' }}>
          <ChevronLeft size={14} /> {language === 'tr' ? 'Ana Sayfaya Dön' : 'Back to Home'}
        </Link>

        {language === 'tr' ? (
          <div>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '36px', fontWeight: 600, color: '#1F3A2E', marginBottom: '8px' }}>Kullanım Şartları</h1>
            <p style={{ fontSize: '13px', color: '#6E7F5B', marginBottom: '2.5rem' }}>Son güncelleme: Mayıs 2025</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', fontSize: '15px', lineHeight: '1.8', color: '#3A3632' }}>
              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>1. Kabul</h2>
                <p>Bu web sitesini kullanarak veya rezervasyon yaparak aşağıdaki kullanım şartlarını kabul etmiş olursunuz. Şartları kabul etmiyorsanız lütfen siteyi kullanmayınız.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>2. Rezervasyon Koşulları</h2>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>Check-in saati: 14:00, Check-out saati: 12:00</li>
                  <li>18 yaşından küçük misafirler yetişkin eşliğinde kabul edilir</li>
                  <li>Evcil hayvan politikası için lütfen önceden iletişime geçiniz</li>
                  <li>Rezervasyon doğrulama e-posta yoluyla gönderilecektir</li>
                </ul>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>3. İptal ve İade Politikası</h2>
                <ul style={{ paddingLeft: '20px' }}>
                  <li><strong>Giriş tarihinden 7+ gün önce:</strong> Ücretsiz iptal, tam iade</li>
                  <li><strong>Giriş tarihinden 3-7 gün önce:</strong> %50 iade</li>
                  <li><strong>Giriş tarihinden 3 günden az önce:</strong> İade yapılmaz</li>
                  <li>No-show durumunda ücret iade edilmez</li>
                </ul>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>4. Ödeme</h2>
                <p>Ödemeler TEB Sanal POS altyapısı üzerinden güvenli şekilde gerçekleştirilmektedir. Tüm fiyatlar KDV dahildir. Fiyatlar TRY üzerinden hesaplanmaktadır; döviz kuru farkından Amorium Hotel sorumlu değildir.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>5. Misafir Davranışı</h2>
                <p>Amorium Hotel, diğer misafirleri veya personeli rahatsız eden, mülke zarar veren misafirleri konaklamayı sonlandırma hakkını saklı tutar.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>6. İletişim</h2>
                <p>📧 <a href="mailto:info@amoriumhotel.com" style={{ color: '#B08D57' }}>info@amoriumhotel.com</a><br />
                  📞 +90 (366) 220 09 09
                </p>
              </section>
            </div>
          </div>
        ) : (
          <div>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '36px', fontWeight: 600, color: '#1F3A2E', marginBottom: '8px' }}>Terms of Use</h1>
            <p style={{ fontSize: '13px', color: '#6E7F5B', marginBottom: '2.5rem' }}>Last updated: May 2025</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', fontSize: '15px', lineHeight: '1.8', color: '#3A3632' }}>
              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>1. Acceptance</h2>
                <p>By using this website or making a reservation, you agree to the following terms of use. If you do not accept the terms, please do not use the site.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>2. Reservation Conditions</h2>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>Check-in time: 14:00, Check-out time: 12:00</li>
                  <li>Guests under 18 years old are accepted with adult supervision</li>
                  <li>For pet policy, please contact us in advance</li>
                  <li>Reservation confirmation will be sent by email</li>
                </ul>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>3. Cancellation & Refund Policy</h2>
                <ul style={{ paddingLeft: '20px' }}>
                  <li><strong>7+ days before check-in:</strong> Free cancellation, full refund</li>
                  <li><strong>3-7 days before check-in:</strong> 50% refund</li>
                  <li><strong>Less than 3 days before check-in:</strong> No refund</li>
                  <li>No-show charges are non-refundable</li>
                </ul>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>4. Payment</h2>
                <p>Payments are processed securely through TEB Virtual POS infrastructure. All prices include VAT. Prices are calculated in TRY; Amorium Hotel is not responsible for exchange rate differences.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>5. Guest Conduct</h2>
                <p>Amorium Hotel reserves the right to terminate the stay of guests who disturb other guests or staff, or damage property.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>6. Contact</h2>
                <p>📧 <a href="mailto:info@amoriumhotel.com" style={{ color: '#B08D57' }}>info@amoriumhotel.com</a><br />
                  📞 +90 (366) 220 09 09
                </p>
              </section>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
